import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n'


import moment from "moment"
import 'moment/locale/fr'
import 'moment/locale/de'
import 'moment/locale/nl'

import App from "./js/components/App"
import storeProvider from './js/storeProvider'
//import store from "./js/store"
import './index.css'

// Import languages
import en from './lang/en.json'
import nl from './lang/nl.json'
import de from './lang/de.json'
import fr from './lang/fr.json'

import {checkLoggedIn} from './js/actions/userActions'

storeProvider.init()
const store = storeProvider.getStore()

// Get default browser language
let lang = (navigator.language || navigator.userLanguage).substring(0, 2)
const languages = ['en', 'nl', 'de', 'fr']

if(languages.indexOf(lang) === -1) lang = 'en'

// Set localization
syncTranslationWithStore(store)
store.dispatch(loadTranslations({
  en: en,
  nl: nl,
  de: de,
  fr: fr
}))
store.dispatch(setLocale(lang))
// Set moment language to browser language
moment.updateLocale(lang)

// Check if user is logged in before rendering
store.dispatch(checkLoggedIn())

const root = document.getElementById('root')

ReactDOM.render(<Provider store={store}>
     <App />
</Provider>, root);



// WEBPACK FOOTER //
// ./src/index.js